const schema = () => ({
  type: "object",
  required: [],
  properties: {
    firstname: {
      type: "string",
      title: "firstname",
    },
    lastname: {
      type: "string",
      title: "lastname",
    },
    national_code: {
      type: "string",
      title: "national_code",
      minLength: 10,
      maxLength: 10,
    },
    birth_date: {
      type: "string",
      title: "birth_date",
      format: "date",
    },
    medical_number: {
      type: "string",
      title: "medical_number",
    },
    specialist: {
      type: "string",
      title: "specialist",
      oneOf: [
        { const: "generalDentist", title: "generalDentist" },
        { const: "restorativeDentistry", title: "restorativeDentistry" },
        { const: "prosthodontics", title: "prosthodontics" },
        { const: "orthodontics", title: "orthodontics" },
      ],
    },
    gender: {
      type: "number",
      title: "gender",
      oneOf: [
        { const: 1, title: "man" },
        { const: 0, title: "woman" },
      ],
    },
    email: {
      type: "string",
      title: "email",
      format: "email",
    },
  },
});

export default schema;
